import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Instructions_ds_instructions_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { entityName: string, enabled: boolean, fullTextSearch?: string, typeIds?: number[], entityKey1: number, entityKey2?: number, entityKey3?: number, entityKey4?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, Enabled?: boolean, EntityKey1?: number, EntityKey2?: number, EntityKey3?: number, EntityKey4?: number, EntityName?: string, Instructions?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, TypeId?: number, Type?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.entityName)) {
      missingRequiredInParams.push('\'entityName\'');
    }
    if (isNil(inParams.enabled)) {
      missingRequiredInParams.push('\'enabled\'');
    }
    if (isNil(inParams.entityKey1)) {
      missingRequiredInParams.push('\'entityKey1\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Instructions/datasources/ds_instructions_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { entityName: string, enabled: boolean, fullTextSearch?: string, typeIds?: number[], entityKey1: number, entityKey2?: number, entityKey3?: number, entityKey4?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, Enabled?: boolean, EntityKey1?: number, EntityKey2?: number, EntityKey3?: number, EntityKey4?: number, EntityName?: string, Instructions?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, TypeId?: number, Type?: { Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.entityName)) {
      missingRequiredInParams.push('\'entityName\'');
    }
    if (isNil(inParams.enabled)) {
      missingRequiredInParams.push('\'enabled\'');
    }
    if (isNil(inParams.entityKey1)) {
      missingRequiredInParams.push('\'entityKey1\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Instructions/datasources/ds_instructions_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { entityName: string, enabled: boolean, fullTextSearch?: string, typeIds?: number[], entityKey1: number, entityKey2?: number, entityKey3?: number, entityKey4?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, Enabled?: boolean, EntityKey1?: number, EntityKey2?: number, EntityKey3?: number, EntityKey4?: number, EntityName?: string, Instructions?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, TypeId?: number, Type?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.entityName)) {
      missingRequiredInParams.push('\'entityName\'');
    }
    if (isNil(inParams.enabled)) {
      missingRequiredInParams.push('\'enabled\'');
    }
    if (isNil(inParams.entityKey1)) {
      missingRequiredInParams.push('\'entityKey1\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Instructions/datasources/ds_instructions_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      entityName: string, enabled: boolean, fullTextSearch?: string, typeIds?: number[], entityKey1: number, entityKey2?: number, entityKey3?: number, entityKey4?: number    }) {
        if(isNil(inParams.entityName)) {
          return true; 
        }
        if(isNil(inParams.enabled)) {
          return true; 
        }
        if(isNil(inParams.entityKey1)) {
          return true; 
        }
      return false;
    }
}
